import Vue from 'vue';
import format from 'date-fns/format';

/**
 * Formats a date and time string in ISO format, to a date, ignoring the time and timezone of the date.
 * This filter is used for fields that are stored on the server as date objects, in order to prevent
 * the timezone from affecting the formatting.
 * @param {string} value - date string in ISO-8601 format (eg. "2018-01-01T00:00:00.000Z")
 * @param {string} formatString - format to use for result
 * @return {string} - the formatted date
 *
 */
const formatDateIgnoreTime = (value, formatString = 'YYYY-MM-DD') => {
  if (value && value.length >= 10) {
    return format(value.substr(0, 10), formatString);
  }
  return '';
};
export default formatDateIgnoreTime;

Vue.filter('formatDateIgnoreTime', formatDateIgnoreTime);
